var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00004 9.33334C2.36823 9.33334 2.66671 9.63182 2.66671 10V12.6667C2.66671 12.8435 2.73695 13.0131 2.86197 13.1381C2.98699 13.2631 3.15656 13.3333 3.33337 13.3333H12.6667C12.8435 13.3333 13.0131 13.2631 13.1381 13.1381C13.2631 13.0131 13.3334 12.8435 13.3334 12.6667V10C13.3334 9.63182 13.6319 9.33334 14 9.33334C14.3682 9.33334 14.6667 9.63182 14.6667 10V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667H3.33337C2.80294 14.6667 2.29423 14.456 1.91916 14.0809C1.54409 13.7058 1.33337 13.1971 1.33337 12.6667V10C1.33337 9.63182 1.63185 9.33334 2.00004 9.33334Z",
    fill: "#07364B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19526 6.19526C4.45561 5.93491 4.87772 5.93491 5.13807 6.19526L8 9.05719L10.8619 6.19526C11.1223 5.93491 11.5444 5.93491 11.8047 6.19526C12.0651 6.45561 12.0651 6.87772 11.8047 7.13807L8.4714 10.4714C8.21106 10.7318 7.78894 10.7318 7.5286 10.4714L4.19526 7.13807C3.93491 6.87772 3.93491 6.45561 4.19526 6.19526Z",
    fill: "#07364B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 1.33334C8.36823 1.33334 8.66671 1.63182 8.66671 2.00001V10C8.66671 10.3682 8.36823 10.6667 8.00004 10.6667C7.63185 10.6667 7.33337 10.3682 7.33337 10V2.00001C7.33337 1.63182 7.63185 1.33334 8.00004 1.33334Z",
    fill: "#07364B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.cd098c1d08c5515a4b9b87a902896847.svg";
export { ForwardRef as ReactComponent };